/**
 * GeoIpAttribution (OCP-848) - the CC BY 4.0 credit DB-IP asks for on every
 * page that displays results of its IP to Country Lite database. Countries
 * shown in the login and redeem tables come from it for requests on the
 * DNS-only hosts (account.orboto.io, mail.orboto.io).
 */
export function GeoIpAttribution() {
  return (
    <p data-testid="geoip-attribution" className="mt-2 text-[11px] text-gray-400 dark:text-gray-500">
      Countries:{' '}
      <a href="https://db-ip.com" target="_blank" rel="noreferrer" className="underline">
        IP Geolocation by DB-IP
      </a>{' '}
      (
      <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noreferrer" className="underline">
        CC BY 4.0
      </a>
      ) or Cloudflare.
    </p>
  );
}
